<template>
  <el-dialog :visible="dialogVisible" width="500px" :show-close="true" @close="closeDialog">
    <div style="text-align: center; padding: 20px;">
      <!-- 二维码盒子 -->
      <div style="padding: 10px; box-shadow: 1px 1px 8px 0px rgba(100, 100, 111, 0.2);">
        <div id="qrcode-content">
          <!-- 上方文字：合作伙伴 -->
          <p style="margin: 10px 0; color: #333;font-size: 18px;">合作伙伴：{{ partnerName }}</p>

          <!-- 二维码图片 -->
          <img v-show="qrCodeDataUrl" :src="qrCodeDataUrl" alt="二维码" style="width: 300px; height: 300px;" />
          <div v-show="!qrCodeDataUrl" style="width: 300px; height: 300px;line-height: 300px;">
            <i class="el-icon-loading" style="font-size: 30px;"></i>
          </div>


          <!-- 下方文字：推荐ID -->
          <p style="margin: 10px 0; color: #333;font-size: 18px;">推荐ID：{{ referralId }}</p>
        </div>
      </div>

      <!-- 下载二维码按钮 -->
      <el-button type="primary" @click="downloadQrCode" style="margin-top: 20px;">下载二维码</el-button>
    </div>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  name: "QrCodeDialog",
  data() {
    return {
      url: this.GLOBAL.domain + "Clerk/index",
      dialogVisible: false,
      partnerName: '',
      referralId: '',
      qrCodeUrl: '', // 保存二维码链接
      row: null,
      qrCodeDataUrl: ''
    };
  },
  methods: {
    // 初始化组件，接收row数据
    async initDialog(row) {
      var resource = this.$resource(this.url);
      resource.query({ act: 'share_qr_code', token: this.$cookies.get('token'), id: row.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          const result = JSON.parse(Base64.decode(res.data.Data));

          // result.qr_code是一张图片的地址，把result.qr_code转为base64格式的图片赋值给this.qrCodeDataUrl
          this.fetchQrCodeAsBase64(result.qr_code)
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });



      this.dialogVisible = true
      this.row = row;
      // 假设row包含partnerName, referralId, qrCodeUrl
      this.partnerName = row.name || "未知";
      this.referralId = row.id || "未知";
    },
    // 下载二维码截图
    async downloadQrCode() {
      const qrcodeContent = document.getElementById("qrcode-content");
      try {
        const canvas = await html2canvas(qrcodeContent);
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "二维码.png";
        link.click();
      } catch (error) {
        console.error("下载二维码失败", error);
      }
    },
    async fetchQrCodeAsBase64(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          this.qrCodeDataUrl = reader.result;
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('获取 QR Code 失败:', error);
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.partnerName = '';
      this.referralId = '';
      this.qrCodeUrl = '';
      setTimeout(() => {
        this.qrCodeDataUrl = ''
      }, 500);
    }
  }
};
</script>

<style scoped>
/* 元素垂直、水平居中对齐 */
#qrcode-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  /* box-shadow: 1px 1px 8px 0px rgba(100, 100, 111, 0.2); */

  margin: 0 auto;
  width: 380px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background: url(../../assets/baise.png) no-repeat center; */
}
</style>



// WEBPACK FOOTER //
// src/components/base/QrCodeDialog.vue